function createPageName(pageName?: string) {
  if (!pageName) return 'Patient Portal | Circle Medical'
  return `${pageName} | Circle Medical`
}

export default createPageName
